import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError, BehaviorSubject } from "rxjs";
import { catchError, switchMap, filter, take, finalize } from "rxjs/operators";
import { LoginService } from "../services/login.service";
import { environment } from "../../environments/environment";
import { sha256 } from "js-sha256";
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  constructor(private loginService: LoginService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // alert('Your session has expired. Login again');
          // this.loginService.signOut();
          return this.handle401Error(request, next);
        }
        if (err.status === 403) {
          this.loginService.signOut(); // Force logout on server error
          return throwError(() => new Error("Server error"));
        }
        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.refreshTokenSubject.next(null);

      return this.loginService.refreshToken().pipe(
        switchMap((user: any) => {
          if (user) {
            this.refreshTokenSubject.next(user.token);
            // localStorage.setItem('currentUser', JSON.stringify(user));
            return next.handle(this.addToken(request, user.token));
          }

          return <any>this.loginService.signOut();
        }),
        catchError((err) => {
          return <any>this.loginService.signOut();
        }),
        finalize(() => {
          this.isRefreshing = false;
        })
      );
    } else {
      this.isRefreshing = false;

      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((token) => {
          return next.handle(this.addToken(request, token));
        })
      );
    }
  }
  private addToken(request: HttpRequest<any>, token: string) {
    if (!token) {
      return <any>this.loginService.signOut();
    }
    const body = JSON.stringify(request.body);
    const checksum = sha256.hmac(`${environment.secretKey}`, body);
    return request.clone({
      setHeaders: {
        accesskey: `${environment.accessKey}`,
        checksum: `${checksum}`,
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
